var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-arrow-month" },
    _vm._l(_vm.daysInMonth, function (day) {
      return _c("range-calendar-day", {
        key: day,
        attrs: {
          day: _vm.getDay(day),
          "has-event": _vm.hasEvent(day),
          "day-width": _vm.dayWidth,
          "selected-start-date": _vm.selectedStartDate,
          "selected-end-date": _vm.selectedEndDate,
          "input-selected": _vm.inputSelected,
          "is-first-day": _vm.firstAvailableDay === _vm.getDay(day),
          "is-day-disabled": _vm.isDayDisabled(day),
          "current-focus": _vm.currentFocus,
        },
        on: {
          "refresh-focusable": function ($event) {
            return _vm.$emit("refresh-focusable", $event)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }